const taxableHPs = [
  {
    id: '4',
    label: "4 Φορ. Ίπποι (0 - 642 κ.εκ.)",
    value: 642
  },
  {
    id: '5',
    label: "5 Φορ. Ίπποι (643 - 785 κ.εκ.)",
    value: 785
  },
  {
    id: '6',
    label: "6 Φορ. Ίπποι (786 - 928 κ.εκ.)",
    value: 928
  },
  {
    id: '7',
    label: "7 Φορ. Ίπποι (929 - 1071 κ.εκ.)",
    value: 1071
  },
  {
    id: '8',
    label: "8 Φορ. Ίπποι (1072 - 1214 κ.εκ.)",
    value: 1214
  },
  {
    id: '9',
    label: "9 Φορ. Ίπποι (1215 - 1357 κ.εκ.)",
    value: 1357
  },
  {
    id: '10',
    label: "10 Φορ. Ίπποι (1358 - 1499 κ.εκ.)",
    value: 1499
  },
  {
    id: '11',
    label: "11 Φορ. Ίπποι (1500 - 1642 κ.εκ.)",
    value: 1642
  },
  {
    id: '12',
    label: "12 Φορ. Ίπποι (1643 - 1785 κ.εκ.)",
    value: 1785
  },
  {
    id: '13',
    label: "13 Φορ. Ίπποι (1786 - 1928 κ.εκ.)",
    value: 1928
  },
  {
    id: '14',
    label: "14 Φορ. Ίπποι (1929 - 2071 κ.εκ.)",
    value: 2071
  },
  {
    id: '15',
    label: "15 Φορ. Ίπποι (2072 - 2214 κ.εκ.)",
    value: 2214
  },
  {
    id: '16',
    label: "16 Φορ. Ίπποι (2215 - 2357 κ.εκ.)",
    value: 2357
  },
  {
    id: '17',
    label: "17 Φορ. Ίπποι (2358 - 2499 κ.εκ.)",
    value: 2499
  },
  {
    id: '18',
    label: "18 Φορ. Ίπποι (2500 - 2642 κ.εκ.)",
    value: 2642
  },
  {
    id: '19',
    label: "19 Φορ. Ίπποι (2643 - 2785 κ.εκ.)",
    value: 2785
  },
  {
    id: '20',
    label: "20 Φορ. Ίπποι (2786 - 2928 κ.εκ.)",
    value: 2928
  },
  {
    id: '21',
    label: "21 Φορ. Ίπποι (2929 - 3071 κ.εκ.)",
    value: 3071
  },
  {
    id: '22',
    label: "22 Φορ. Ίπποι (3072 - 3214 κ.εκ.)",
    value: 3214
  },
  {
    id: '23',
    label: "23 Φορ. Ίπποι (3215 - 3357 κ.εκ.)",
    value: 3357
  },
  {
    id: '24',
    label: "24 Φορ. Ίπποι (3358 - 3499 κ.εκ.)",
    value: 3499
  },
  {
    id: '25',
    label: "25 Φορ. Ίπποι (3500 - 3642 κ.εκ.)",
    value: 3642
  },
  {
    id: '26',
    label: "26 Φορ. Ίπποι (3643 - 3785 κ.εκ.)",
    value: 3785
  },
  {
    id: '27',
    label: "27 Φορ. Ίπποι (3786 - 3928 κ.εκ.)",
    value: 3928
  },
  {
    id: '28',
    label: "28 Φορ. Ίπποι (3929 - 4071 κ.εκ.)",
    value: 4071
  },
  {
    id: '29',
    label: "29 Φορ. Ίπποι (4072 - 4214 κ.εκ.)",
    value: 4214
  },
  {
    id: '30',
    label: "30 Φορ. Ίπποι (4215 - 4357 κ.εκ.)",
    value: 4357
  },
  {
    id: '31',
    label: "31 Φορ. Ίπποι (4358 - 4499 κ.εκ.)",
    value: 4499
  },
  {
    id: '32',
    label: "32 Φορ. Ίπποι (4500 - 4642 κ.εκ.)",
    value: 4642
  },
  {
    id: '33',
    label: "33 Φορ. Ίπποι (4643 - 4785 κ.εκ.)",
    value: 4785
  },
  {
    id: '34',
    label: "34 Φορ. Ίπποι (4786 - 4928 κ.εκ.)",
    value: 4928
  },
  {
    id: '35',
    label: "35 Φορ. Ίπποι (4929 - 5071 κ.εκ.)",
    value: 5071
  },
  {
    id: '36',
    label: "36 Φορ. Ίπποι (5072 - 5214 κ.εκ.)",
    value: 5214
  },
  {
    id: '37',
    label: "37 Φορ. Ίπποι (5215 - 5357 κ.εκ.)",
    value: 5357
  },
  {
    id: '38',
    label: "38 Φορ. Ίπποι (5358 - 5499 κ.εκ.)",
    value: 5499
  },
  {
    id: '39',
    label: "39 Φορ. Ίπποι (5500 - 5642 κ.εκ.)",
    value: 5642
  },
  {
    id: '40',
    label: "40 Φορ. Ίπποι (5643 - 5785 κ.εκ.)",
    value: 5785
  },
  {
    id: '41',
    label: "41 Φορ. Ίπποι (5786 - 5928 κ.εκ.)",
    value: 5928
  },
  {
    id: '42',
    label: "42 Φορ. Ίπποι (5929 - 6071 κ.εκ.)",
    value: 6071
  },
  {
    id: '43',
    label: "43 Φορ. Ίπποι (6072 - 6214 κ.εκ.)",
    value: 6214
  },
  {
    id: '44',
    label: "44 Φορ. Ίπποι (6215 - 6357 κ.εκ.)",
    value: 6357
  },
  {
    id: '45',
    label: "45 Φορ. Ίπποι (6358 - 6499 κ.εκ.)",
    value: 6499
  },
  {
    id: '46',
    label: "46 Φορ. Ίπποι (6500 - 6642 κ.εκ.)",
    value: 6642
  },
  {
    id: '47',
    label: "47 Φορ. Ίπποι (6643 - 6785 κ.εκ.)",
    value: 6785
  },
  {
    id: '48',
    label: "48 Φορ. Ίπποι (6786 - 6928 κ.εκ.)",
    value: 6928
  },
  {
    id: '49',
    label: "49 Φορ. Ίπποι (6929 - 7071 κ.εκ.)",
    value: 7071
  },
  {
    id: '50',
    label: "50 Φορ. Ίπποι (7072 - 7214 κ.εκ.)",
    value: 7214
  },
  {
    id: '51',
    label: "51 Φορ. Ίπποι (7215 - 7357 κ.εκ.)",
    value: 7357
  },
  {
    id: '52',
    label: "52 Φορ. Ίπποι (7358 - 7499 κ.εκ.)",
    value: 7499
  },
  {
    id: '53',
    label: "53 Φορ. Ίπποι (7500 - 7642 κ.εκ.)",
    value: 7642
  },
  {
    id: '54',
    label: "54 Φορ. Ίπποι (7643 - 7785 κ.εκ.)",
    value: 7785
  },
  {
    id: '55',
    label: "55 Φορ. Ίπποι (7786 - 7928 κ.εκ.)",
    value: 7928
  },
  {
    id: '56',
    label: "56 Φορ. Ίπποι (7929 - 8071 κ.εκ.)",
    value: 8071
  },
  {
    id: '57',
    label: "57 Φορ. Ίπποι (8072 - 8214 κ.εκ.)",
    value: 8214
  },
  {
    id: '58',
    label: "58 Φορ. Ίπποι (8215 - 8357 κ.εκ.)",
    value: 8357
  },
  {
    id: '59',
    label: "59 Φορ. Ίπποι (8358 - 8499 κ.εκ.)",
    value: 8499
  },
  {
    id: '60',
    label: "60 Φορ. Ίπποι (8500 - 8642 κ.εκ.)",
    value: 8642
  }
];

export default taxableHPs;
